var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.eventItem.photo)?_c('div',[_c('img',{staticStyle:{"height":"150px"},attrs:{"src":_vm.eventItem.photo.url}})]):_vm._e(),(_vm.eventItem.business.photo)?_c('div',[_c('img',{staticStyle:{"height":"150px"},attrs:{"src":_vm.eventItem.business.photoUrl}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }